const getHtmlDocument = html =>
  new DOMParser().parseFromString(html, 'text/html');
export default getHtmlDocument;
